/**
 * Generic document helpers — Phase 5 replacement.
 * Delegates to /api/documents/{collection}/{id} (generic_documents table) on dash-api.
 */

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token
        ? {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'}
        : {'Content-Type': 'application/json'};
}

async function apiFetch(path, opts = {}) {
    const resp = await fetch(`${BASE}${path}`, {headers: authHeaders(), ...opts});
    if (resp.status === 404) return null;
    if (!resp.ok) throw new Error(`${opts.method || 'GET'} ${path} → ${resp.status}`);
    const ct = resp.headers.get('content-type') || '';
    if (resp.status === 204 || !ct.includes('application/json')) return null;
    return resp.json();
}

export const getDoc = async (collectionName, docId) => {
    return apiFetch(
        `/api/documents/${encodeURIComponent(collectionName)}/${encodeURIComponent(docId)}`
    );
};

export const setDoc = async (collectionName, docId, data) => {
    await apiFetch(
        `/api/documents/${encodeURIComponent(collectionName)}/${encodeURIComponent(docId)}`,
        {method: 'PUT', body: JSON.stringify(data)}
    );
};

export const listenToDoc = (collectionName, docId, callback) => {
    let cancelled = false;
    getDoc(collectionName, docId)
        .then((data) => { if (!cancelled) callback(data); })
        .catch(() => { if (!cancelled) callback(null); });
    return () => { cancelled = true; };
};

export const updateDoc = async (collectionName, docId, data) => {
    await apiFetch(
        `/api/documents/${encodeURIComponent(collectionName)}/${encodeURIComponent(docId)}`,
        {method: 'PATCH', body: JSON.stringify(data)}
    );
};

export const getCollection = async (collectionName) => {
    const data = await apiFetch(`/api/documents/${encodeURIComponent(collectionName)}`);
    return Array.isArray(data) ? data : [];
};

export const deleteDoc = async (collectionName, docId) => {
    await apiFetch(
        `/api/documents/${encodeURIComponent(collectionName)}/${encodeURIComponent(docId)}`,
        {method: 'DELETE'}
    );
};
